import {AnalyticsCustomLink} from './analytics.js';

window.addEventListener("turbolinks:load", () => {

	// One Pagers: Click To Reveal
	if (window.location.href.indexOf("id_navigator/restoration") > -1) {
		$(".onepager-expand-text").click(function(){
			$(".intro").show();
			$(".expanded").hide();
			$(".onepager-expand-text").show();
			$(this).hide();
			$(this).parent().find(".intro").hide();
			$(this).parent().find(".expanded").show();
		});
	}

	// Contact
	if (window.location.href.indexOf("id_navigator/contact") > -1) {
		$("#view-phone-number").click(function(){
			$("#view-phone-number").hide();
			$("h3").fadeIn();
			$("#mainspantextcontact").fadeIn();
			AnalyticsCustomLink(this, "support_id_navigator_contact_view_phone_number");
		});
	}

	// Solutions
	if (window.location.href.indexOf("id_navigator/solutions/") > -1) {

		if ($(".twistee").length > 0) {

			//Move the Twistee titles into a container and add the Chevron
		    $(".twistee").each(function(){
		        $(this).find("h3").first().wrap("<div class='twist-title-container'></div>");
		        $(this).find(".twist-title-container").append("<div class=\"chevron\">&rsaquo;</div>");
		    });

			// Add Click Event for twistees
			$(".twistee").click(function(){
				$(this).find(".twistee_content").slideToggle();
				$(this).find(".chevron").toggleClass("open");
			});
		}

	    // Add classes in KB docs to differentiate between small inline icon type images and large screenshots
	    if ($("#kbwrapper img").length > 0) {
	        var kbwrapperImages = document.querySelectorAll("#kbwrapper img");
	        for (var i = 0; i < kbwrapperImages.length; i++) {
	            var img = new Image();
	            img.onload = function() {
	                if (this.height > 50) {
	                    $("img[src$='"+this.src+"']").addClass("img-lg");
	                } else {
	                    $("img[src$='"+this.src+"']").addClass("img-sm");
	                }
	            }
	            img.src = kbwrapperImages[i].src
	        }
	    }
	}
});
